import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/opt/build/repo/app/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/app/layouts/default.vue").then(m => m.default || m))
}